import * as React from "react"
import * as ReactDOM from "react-dom"
import * as moment from 'moment';

import { default as RoomPeriodPicker } from '../../utils/period_picker/RoomPeriodPicker'

import { StartEnd, DisabledProps, PrefixProps } from '../../utils/period_picker/PeriodPicker'
import { FocusedInputShape } from 'react-dates';

declare var $: any;

type Props = StartEnd & {
  startDateSelector: string
  endDateSelector: string
  roomSelector: string
  prefix: string
  room: number
}

type State = StartEnd & {
  room: number
  focusedInput: FocusedInputShape

}
export default class BnbRoomContactFormPeriodPicker extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
      startDate: this.props.startDate !== null ? moment(this.props.startDate, "DD-MM-YYYY") : null,
      endDate:   this.props.endDate   !== null ? moment(this.props.endDate,   "DD-MM-YYYY") : null,
      room: this.props.room,
      focusedInput: null,
    }
  }

  componentWillMount() {
    $(this.props.roomSelector).change(() => {
      this.refreshRoomSelectorValue()
    })
    this.refreshRoomSelectorValue()
  }

  refreshRoomSelectorValue() {
    this.setState({ room: $(this.props.roomSelector).val() })
  }

  onDatesChange(range: StartEnd) {
    this.setState({ ...range  })
  }

  render() {
    return (
      <RoomPeriodPicker
        key={this.state.room}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        room_id={this.state.room}
        prefix={this.props.prefix}
        onDatesChange={(range: StartEnd) => this.onDatesChange(range)}
        onFocusChange={(fi) => this.setState({focusedInput: fi})}
        focusedInput={this.state.focusedInput}
        close={() => null}
      />
    )
  }
}